/* ============================================
   DISTINCT — Main JS v13 FINALE
   Loghi oscillanti su tutto il sito (canvas fixed)
   Intro animata · Cart AJAX · Swiper immagini
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  initIntro();
  initLogoCanvas();
  initRain();
  initHeader();
  initSizeSelectors();
  initAddToCart();
  initCartSidebar();
  initScrollReveal();
  initSoldOutCards();
  initAdmin();
  initEasterEgg();
  refreshCartCount();
});

/* ============================================ INTRO */
function initIntro() {
  if (sessionStorage.getItem('d_intro')) return;
  sessionStorage.setItem('d_intro', '1');

  const src = findImg('logo2_clean.png');
  const intro = document.createElement('div');
  intro.id = 'distinct-intro';
  intro.innerHTML = `<div class="intro-inner"><img class="intro-logo" src="${src}" alt="Distinct"></div>`;
  document.body.appendChild(intro);
  document.body.style.overflow = 'hidden';

  setTimeout(() => intro.classList.add('intro-grow'), 1600);
  setTimeout(() => intro.classList.add('intro-exit'), 2400);
  setTimeout(() => { intro.remove(); document.body.style.overflow = ''; }, 3200);
}

function findImg(name) {
  for (const img of document.querySelectorAll('img')) {
    if (img.src && img.src.includes(name)) return img.src;
  }
  return '';
}

/* ============================================
   LOGO CANVAS — brillantini che compaiono/scompaiono
   Su tutto il sito (canvas fixed)
   ============================================ */
function initLogoCanvas() {
  const canvas = document.getElementById('starfield');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  let W, H, items = [];

  const imgScript = new Image();
  const imgSpine  = new Image();
  let loaded = 0;

  function onLoad() {
    loaded++;
    if (loaded === 2) { resize(); createItems(); animate(); }
  }

  imgScript.onload  = onLoad;
  imgSpine.onload   = onLoad;
  imgScript.onerror = onLoad;
  imgSpine.onerror  = onLoad;

  setTimeout(() => {
    imgScript.src = findImg('logo2_clean.png');
    imgSpine.src  = findImg('d_spine_v3.png');
    if (!imgScript.src) onLoad();
    if (!imgSpine.src)  onLoad();
  }, 200);

  function resize() {
    W = canvas.width  = window.innerWidth;
    H = canvas.height = window.innerHeight;
  }

  function createItems() {
    items = [];
    const count = Math.max(12, Math.floor((W * H) / 18000));
    for (let i = 0; i < count; i++) {
      items.push(makeItem());
      // Stagger: partono già in fasi diverse
      items[i].alpha = Math.random() * items[i].targetAlpha;
      items[i].state = Math.random() > 0.5 ? 'hold' : 'in';
      items[i].holdTimer = Math.floor(Math.random() * items[i].holdMax);
    }
  }

  function makeItem() {
    return {
      x:          Math.random() * W,
      y:          Math.random() * H,
      size:       Math.random() * 24 + 10,
      alpha:      0,
      targetAlpha: Math.random() * 0.13 + 0.04,
      speed:      Math.random() * 0.007 + 0.003,
      state:      'in',
      holdTimer:  0,
      holdMax:    Math.floor(Math.random() * 140 + 50),
      rotation:   Math.random() * Math.PI * 2,
      useSpine:   Math.random() > 0.55,
    };
  }

  function animate() {
    ctx.clearRect(0, 0, W, H);

    items.forEach((item, i) => {
      if (item.state === 'in') {
        item.alpha += item.speed;
        if (item.alpha >= item.targetAlpha) {
          item.alpha = item.targetAlpha;
          item.state = 'hold';
          item.holdTimer = 0;
        }
      } else if (item.state === 'hold') {
        item.holdTimer++;
        if (item.holdTimer >= item.holdMax) item.state = 'out';
      } else {
        item.alpha -= item.speed;
        if (item.alpha <= 0) {
          // Reset con nuova posizione casuale
          const fresh = makeItem();
          items[i] = fresh;
          return;
        }
      }

      if (item.alpha <= 0) return;
      const img = item.useSpine ? imgSpine : imgScript;
      if (!img.complete || !img.naturalWidth) return;

      ctx.save();
      ctx.globalAlpha = item.alpha;
      ctx.translate(item.x, item.y);
      ctx.rotate(item.rotation);
      const h = item.size / 2;
      ctx.drawImage(img, -h, -h, item.size, item.size);
      ctx.restore();
    });

    requestAnimationFrame(animate);
  }

  window.addEventListener('resize', () => { resize(); createItems(); }, { passive: true });
}

/* ============================================ RAIN */
function initRain() {
  const c = document.createElement('div');
  c.className = 'rain-container';
  document.body.appendChild(c);
  function drop() {
    const d = document.createElement('div');
    d.className = 'rain-drop';
    const dur = Math.random()*1.5+0.8, del = Math.random()*3;
    d.style.cssText = `left:${Math.random()*100}%;height:${Math.random()*80+40}px;animation-duration:${dur}s;animation-delay:${del}s;opacity:${Math.random()*0.12+0.03};`;
    c.appendChild(d);
    setTimeout(() => { d.remove(); drop(); }, (dur+del)*1000+500);
  }
  for (let i = 0; i < 28; i++) drop();
}

/* ============================================ HEADER */
function initHeader() {
  const h = document.querySelector('.site-header');
  if (!h) return;
  window.addEventListener('scroll', () => h.classList.toggle('scrolled', window.scrollY > 40), { passive: true });
}

/* ============================================ SIZE SELECTORS */
function initSizeSelectors() {
  document.addEventListener('click', e => {
    const btn = e.target.closest('.size-btn');
    if (!btn || btn.disabled) return;
    const group = btn.closest('.size-selector');
    if (!group) return;
    group.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const form = btn.closest('.product-add-form');
    if (form) {
      const inp = form.querySelector('.variant-id-input');
      if (inp) inp.value = btn.dataset.variantId;
    }
  });
}

/* ============================================ ADD TO CART */
function initAddToCart() {
  document.addEventListener('submit', async e => {
    if (!e.target.classList.contains('product-add-form')) return;
    e.preventDefault();
    const form = e.target;
    const inp  = form.querySelector('.variant-id-input');
    const sbtn = form.querySelector('.add-to-cart-btn');
    const vid  = inp ? inp.value : null;
    const name = form.dataset.productName || 'Prodotto';

    if (!vid || vid === 'undefined' || vid === '') {
      showToast('Seleziona una taglia', 'error'); return;
    }
    if (sbtn) { sbtn.disabled = true; sbtn.textContent = '...'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        showToast(err.description || 'Non disponibile', 'error'); return;
      }
      await res.json();
      await refreshCartCount();
      window.location.href = '/cart';
    } catch { showToast('Errore di rete', 'error'); }
    finally { if (sbtn) { sbtn.disabled = false; sbtn.textContent = 'Aggiungi al Carrello'; } }
  });
}

/* ============================================ CART */
async function getCart() {
  try { return await (await fetch('/cart.js')).json(); }
  catch { return { items: [], item_count: 0, total_price: 0 }; }
}
async function cartChange(varId, qty) {
  try {
    // Shopify richiede il token CSRF per le POST — lo prendiamo dal meta tag
    const token = document.querySelector('meta[name="csrf-token"]')?.content
      || window.Shopify?.cdnHost  // fallback
      || '';

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...(token ? { 'X-CSRF-Token': token } : {})
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: parseInt(varId, 10), quantity: parseInt(qty, 10) })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      console.error('cartChange error:', res.status, err);
    }
    return await res.json().catch(() => ({}));
  } catch(e) { console.error('cartChange fetch error:', e); }
}
async function refreshCartCount() {
  const d = await getCart();
  document.querySelectorAll('.cart-count').forEach(el => el.textContent = d.item_count || 0);
}
function initCartSidebar() {
  // Carrello nativo Shopify - nessun drawer
  refreshCartCount();
}

function openCart() {
  document.querySelector('.cart-sidebar')?.classList.add('open');
  document.getElementById('cartOverlay')?.classList.add('active');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.querySelector('.cart-sidebar')?.classList.remove('open');
  document.getElementById('cartOverlay')?.classList.remove('active');
  document.body.style.overflow = '';
}
window.openCart = openCart;
window.closeCart = closeCart;

/* ============================================ TOAST */
function showToast(msg, type='success') {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.className = `toast ${type} show`;
  clearTimeout(t._timer);
  t._timer = setTimeout(() => t.classList.remove('show'), 3200);
}
window.showToast = showToast;

/* ============================================ SCROLL REVEAL */
function initScrollReveal() {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  els.forEach(el => obs.observe(el));
}

/* ============================================ ADMIN */
function initAdmin() {
  let s = '';
  document.addEventListener('keydown', e => {
    s += e.key.toLowerCase();
    if (s.length > 12) s = s.slice(-12);
    if (s.includes('distinct')) { s = ''; toggleAdmin(); }
  });
}
async function toggleAdmin() {
  const p = document.querySelector('.admin-panel');
  if (!p) return;
  p.classList.toggle('open');
  if (p.classList.contains('open')) {
    const d = await getCart();
    const r  = document.getElementById('adminRevenue');
    const it = document.getElementById('adminItems');
    if (r)  r.textContent  = `€${fmt(d.total_price)}`;
    if (it) it.textContent = d.item_count || 0;
  }
}
async function exportCSV() {
  const d = await getCart();
  const rows = [['Prodotto','Variante','Qty','Prezzo','Totale']];
  (d.items||[]).forEach(i => rows.push([i.product_title, i.variant_title||'', i.quantity, `€${fmt(i.price)}`, `€${fmt(i.line_price)}`]));
  rows.push(['','','','TOTALE',`€${fmt(d.total_price)}`]);
  const csv = rows.map(r => r.join(',')).join('\n');
  const a = document.createElement('a');
  a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
  a.download = `distinct-${Date.now()}.csv`;
  a.click();
  showToast('CSV esportato');
}
window.toggleAdmin = toggleAdmin;
window.exportCSV = exportCSV;

/* ============================================ EASTER EGG */
function initEasterEgg() {
  let clicks = 0;
  let timer;
  const logo = document.querySelector('.site-logo');
  if (!logo) return;

  logo.addEventListener('click', function(e) {
    e.preventDefault(); // impedisce navigazione durante i click
    clicks++;
    clearTimeout(timer);

    if (clicks >= 5) {
      clicks = 0;
      window.open('https://www.instagram.com/p/DR-jigmDo71/?img_index=4&igsh=ZjRyb24wOGZyNmtz', '_blank');
      return;
    }

    // Reset se non clicca entro 2 secondi
    timer = setTimeout(() => { clicks = 0; }, 2000);
  });
}

/* ===== SOLD OUT CARDS — nastro polizia ===== */
function initSoldOutCards() {
  document.querySelectorAll('.product-card').forEach(card => {
    const btn = card.querySelector('.add-to-cart-btn');
    if (btn && btn.disabled) {
      card.classList.add('sold-out');
      // Aggiungi nastro giallo stile polizia
      if (!card.querySelector('.sold-out-tape')) {
        const tape = document.createElement('div');
        tape.className = 'sold-out-tape';
        // Ripeti "ESAURITO" molte volte per riempire il nastro
        tape.textContent = Array(20).fill('ESAURITO').join('  ·  ');
        // Inserisci nell'image wrap
        const imgWrap = card.querySelector('.product-image-wrap, .card-img-swiper-wrap');
        if (imgWrap) imgWrap.appendChild(tape);
        else card.appendChild(tape);
      }
    }
  });
}
